import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";
import type { BroadcastProvider } from "shared/types/mentions";

import type Podcast from "./Podcast";
import type PodcastEpisodeFragment from "./PodcastEpisodeFragment";

@Model()
class PodcastEpisode extends ApplicationRecord {
  static jsonapiType = "podcast_episodes";

  @Attr() author: string;

  @Attr() body: string;

  @Attr({ persist: false }) broadcastProvider?: Nullable<BroadcastProvider>;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) excerpts: string[];

  @Attr() externalMediaUrl: string;

  @Attr({ persist: false }) keywordCounts: Record<string, number>;

  @Attr() mediaFileData: string;

  @Attr() mediaFilename: string;

  @Attr() mediaUrl: string;

  @HasMany() podcastEpisodeFragments: PodcastEpisodeFragment[];

  @Attr() podcastId: string;

  @Attr() publishedAt: string;

  @Attr({ persist: false }) signedUrl: string;

  @BelongsTo() source: Podcast;

  @Attr() title: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() urlHash: string;
}

export default PodcastEpisode;
